import { Section } from "Components/Section";
import { WhatIsThisModal } from "Components/WhatIsThisModal";
import { VerticalRadio } from "Inputs/Radio";
import React from "react";
import { formatDollarsAndCents, formatWholeDollars } from "Tools";

export interface AbuseCoverageModel {
  AbuseCoverages: AbuseCoverage[];
  UnderwritableAbuseCoverage: AbuseCoverage | null;
}

export function AbuseCoverageSection(props: AbuseCoverageModel) {
  return (
    <Section
      title={
        <>
          Abuse or Molestation Coverage{" "}
          <WhatIsThisModal modalTitle={"Abuse or Molestation"}>
            Liability coverage is provided for claims arising out of alleged
            abuse or molestation as well as alleged physical and non-physical
            abuse (verbal, mental or emotional abuse).
          </WhatIsThisModal>
        </>
      }
    >
      <div style={{ margin: "auto", maxWidth: "75%" }}>
        <VerticalRadio
          fieldName="AbuseRateID"
          options={props.AbuseCoverages.map(e => [
            e.ID.toString(),
            <AbuseCoverageText {...e} />,
          ])}
          hasBorderedArea
        />
        {props.UnderwritableAbuseCoverage && (
          <div style={{ marginTop: "1em" }}>
            <em>
              A higher per-occurrence limit of{" "}
              <strong>
                {formatWholeDollars(
                  props.UnderwritableAbuseCoverage.EachActLimit,
                )}
              </strong>{" "}
              is available but subject to additional underwriting. Please
              contact your agent if you wish to apply for coverage.
            </em>
          </div>
        )}
      </div>
    </Section>
  );
}

interface AbuseCoverage {
  ID: number;
  EachActLimit: number;
  AggregateLimit: number;
  Premium: number;
  NeedsUnderwriting: boolean;
}

function AbuseCoverageText(props: AbuseCoverage) {
  if (props.Premium == 0) {
    return (
      <>
        Decline This Coverage (
        <span className="has-text-weight-bold">No Additional Cost</span>)
      </>
    );
  } else {
    return (
      <>
        {formatWholeDollars(props.EachActLimit)} per occurrence /{" "}
        {formatWholeDollars(props.AggregateLimit)} aggregate Abuse or
        Molestation Coverage: Additional Premium of{" "}
        <span className="has-text-weight-bold">
          {formatDollarsAndCents(props.Premium)}
        </span>{" "}
        <span className="is-italic">(Fully Earned at Inception)</span>
      </>
    );
  }
}
